import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import rootReducer from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app', 'auth', 'user', 'promotions', 'orders', 'router'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composedEnhancers = composeWithDevTools(applyMiddleware(thunk));

const store = createStore(persistedReducer, composedEnhancers);
const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./reducers', () => store.replaceReducer(persistedReducer));
}

export { store, persistor };
